import request from '@/api/request'


// 根据orerId查询订单信息
export function getOrderByorderID(orderId) {
	return request({
		url: '/recover/store/accurate/getMoneyByOrderId?orderId='+orderId,
		method: 'get',
	})
}

// 根据支付宝authCode查询支付宝openId
export function getAliPayopenID(authCode) {
	return request({
		url: '/recover/store/alipay/getAlipayOpenId?authCode='+authCode,
		method: 'get',
	
	})
}

// 根据支付宝openId进行收款
export function queryAnQuanFaIsOpen(orderId) {
	return request({
		url: '/recover/store/pendingOrder/queryAnQuanFaIsOpen?orderId='+orderId,
		method: 'get',
	})
}

// 根据支付宝openId进行收款
export function getMoneyByAliPayID(openId,orderId) {
	return request({
		url: '/recover/store/accurate/alipayTransferByOpenid?openId='+openId+'&orderId='+orderId,
		method: 'get',
	})
}



// （改）支付宝打款到回收用户(通过openid)；接入安全发，从回收商记账本账户转账到平台支付宝
export function getMoneyByAliPayID2(openId,orderId) {
	return request({
		url: '/recover/store/accurate/alipayTransferByOpenid2?openId='+openId+'&orderId='+orderId,
		method: 'get',
	})
}

// 差异订单支付宝取消/退收款（agree不为空时调用）
export function alipayCancelReturnPayment(id, openId, nowUserId, agree) {
	return request({
		url: '/recover/admin/use/alipayCancelReturnPayment?id='+id+'&openId='+openId+'&nowUserId='+nowUserId+'&agree='+agree,
		method: 'get',
	})
}